export const USER_STORAGE_KEY = 'looxr-user-filter';
export const CUSTOMER_STORAGE_KEY = 'looxr-customer-filter';
